export enum CustomQuestionTypeEnum {
    simNao = 1,
    nota = 2,
    campoAberto = 3,
}